import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'
import ListStatisticsAdmin from './ListStatisticsAdmin'

const AdminStatisticsRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListStatisticsAdmin /></PrivateRoute7>} />
        {/*<Route path="edit-catalog-roles" element={<PrivateRoute7><EditStatistics /></PrivateRoute7>} />*/}
        {/*<Route path="new-catalog-roles" element={<PrivateRoute7><NewStatistics /></PrivateRoute7>} />*/}
    </Routes>
  )
}

export default AdminStatisticsRoutes